/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Check_DescInputs */

const cs_portals_check_desc = /** @type {(inputs: Portals_Check_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doplňte povinná pole a fotografie, pak export znovu zapněte.`)
};

const en_portals_check_desc = /** @type {(inputs: Portals_Check_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fill mandatory fields and photos, then enable export again.`)
};

/**
* | output |
* | --- |
* | "Fill mandatory fields and photos, then enable export again." |
*
* @param {Portals_Check_DescInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_check_desc = /** @type {((inputs?: Portals_Check_DescInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Check_DescInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_check_desc(inputs)
	return cs_portals_check_desc(inputs)
});